import { Loader } from '@mantine/core'

const ApplicationLoadingScreen = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6">
      <Loader />
      <div className="font-medium text-doubleNickel-gray-700">
        Loading your application...
      </div>
    </div>
  )
}

export default ApplicationLoadingScreen
